import { useInView } from '../../../hooks/useInView';

export default function WhySantislogix() {
  const { ref, inView } = useInView();

  const points = [
    { icon: 'ri-building-line', label: 'Industry Understanding', body: 'We speak the language of your industry — medical, legal, home services, and local enterprise.' },
    { icon: 'ri-shield-line', label: 'Compliance Awareness', body: 'Every system is designed with regulatory nuance and data security built in from the start.' },
    { icon: 'ri-cpu-line', label: 'Structured AI Design', body: 'Not plug-and-play tools. Purpose-architected systems that support long-term growth.' },
  ];

  return (
    <section className="bg-white py-40">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`text-center mb-8 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <p className="text-teal-600 text-xs font-semibold tracking-[0.2em] uppercase mb-6">Our Difference</p>
          <h2 className="font-serif text-6xl lg:text-7xl font-bold text-slate-900 leading-tight max-w-4xl mx-auto">
            Not an Automation Vendor.<br />
            <span className="text-teal-600">A Strategic Systems Partner.</span>
          </h2>
        </div>

        <p className={`text-center text-slate-500 text-xl font-light max-w-2xl mx-auto mb-24 leading-relaxed transition-all duration-700 delay-200 ${inView ? 'opacity-100' : 'opacity-0'}`}>
          Most agencies install tools. We architect operational ecosystems that support long-term growth — not short-term noise.
        </p>

        <div className="grid lg:grid-cols-3 gap-8">
          {points.map((p, i) => (
            <div
              key={i}
              className={`border border-slate-100 rounded-2xl p-10 hover:border-teal-200 hover:bg-teal-50/30 transition-all duration-500 group ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 150}ms` }}
            >
              <div className="w-10 h-10 flex items-center justify-center mb-6">
                <i className={`${p.icon} text-2xl text-teal-600`} />
              </div>
              <h3 className="font-bold text-slate-900 text-lg mb-3">{p.label}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{p.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
